function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u9875\\u9762-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u5728\\u7EBF\\u804A\\u5929\\uFF08\\u7BA1\\u7406\\u5E10\\u53F7\\u662F\\u7FA4\\u4E3B\\uFF09\\u5F39\\u6846",
  transform: "translate(-521.000000, -220.000000)",
  fill: "#1673FF",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "\\u7F16\\u7EC4-10",
  transform: "translate(389.000000, 80.000000)"
}, React.createElement("g", {
  id: "\\u7F16\\u7EC4-14",
  transform: "translate(132.000000, 140.000000)"
}, React.createElement("path", {
  d: "M5,0 C5.27161545,0 5.49180328,0.220187828 5.49180328,0.491803279 L5.49207677,4.50782204 L9.50819672,4.50819672 C9.74963268,4.50819672 9.95043446,4.68217229 9.99207639,4.91159774 L10,5 C10,5.27161545 9.77981217,5.49180328 9.50819672,5.49180328 L5.49207677,5.49197557 L5.49180328,9.50819672 C5.49180328,9.74963268 5.31782771,9.95043446 5.08840226,9.99207639 L5,10 C4.72838455,10 4.50819672,9.77981217 4.50819672,9.50819672 L4.50792323,5.49197557 L0.491803279,5.49180328 C0.250367322,5.49180328 0.0495655374,5.31782771 0.00792360926,5.08840226 L0,5 C0,4.72838455 0.220187828,4.50819672 0.491803279,4.50819672 L4.50792323,4.50782204 L4.50819672,0.491803279 C4.50819672,0.250367322 4.68217229,0.0495655374 4.91159774,0.00792360926 L5,0 Z",
  id: "\\u8DEF\\u5F84"
})))));

var SvgAddLinkMan = function SvgAddLinkMan(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAddLinkMan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/addLinkMan.7335e11b.svg";
export { ForwardRef as ReactComponent };